/* eslint-disable */
import TextField from '@mui/material/TextField';
import { ValidatorComponent } from 'react-material-ui-form-validator';
/* eslint-enable */

export default class TextValidator extends ValidatorComponent {
    renderValidatorComponent() {
        /* eslint-disable no-unused-vars */
        const {
            error,
            errorMessages,
            validators,
            requiredError,
            helperText,
            validatorListener,
            withRequiredValidator,
            containerProps,
            ...rest
        } = this.props;
        const { isValid } = this.state;
        return (
            <TextField
                {...rest}

                variant="standard"
                margin="normal"
                fullWidth
                error={!isValid || error}
                helperText={(!isValid && this.getErrorMessage()) || helperText}
            />
        );
    }
}